import * as actions from './block.actions';
import watch from './block.operations';
import reducer, { initState } from './block.reducers';

export { actions, watch, initState };

export default reducer;
